import { useLayoutEffect, useRef, useState } from "react";

// Scales a fixed-size sheet down to the available width (phones), keeping it readable and fully visible
export const FitToWidth = ({ width, height, children }) => {
  const box = useRef(null);
  const [s, setS] = useState(1);
  useLayoutEffect(() => {
    const el = box.current;
    if (!el) return;
    const mm = 96 / 25.4;
    const update = () => setS(Math.min(1, el.clientWidth / (width * mm)));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [width]);
  if (!height) {  // variable-height sheet: zoom keeps the layout height right; reset when printing
    return (
      <div ref={box} className="w-full" data-testid="fit-to-width">
        <div style={{ width: `${width}mm`, zoom: s }} className="mx-auto print:![zoom:1]">{children}</div>
      </div>
    );
  }
  return (
    <div ref={box} className="w-full" style={{ height: `calc(${height}mm * ${s})` }} data-testid="fit-to-width">
      <div style={{ width: `${width}mm`, transform: `scale(${s})`, transformOrigin: "top left" }}>{children}</div>
    </div>
  );
};
